import { useStores } from '@monorepo/controlled/src/hooks/use-stores';
import { IAdminxStore } from '../../../../stores';
import React, { useEffect } from 'react';
import { id } from '@monorepo/tools/src/lib/types/primitives';
import { observer } from 'mobx-react';
import { Spinner } from '@monorepo/base/src/components/spinner/spinner';
import { Flex } from '@monorepo/base/src/components/flex/flex';
import { Spacer } from '@monorepo/base/src/components/spacer/spacer';
import { DestinationsWeightTable } from '../destinations/destinations-weight-table';
import styles from './max-sales-inline-edit.modal.module.scss';

type Props = {
	id: id;
};

export const MaxSalesInlineEditModal = observer(({ id }: Props) => {
	const { campaignStore } = useStores<IAdminxStore>();
	const campaign = campaignStore.getCrud().getData();
	const links = campaign.getCampaignDestinations();

	useEffect(() => {
		campaignStore.getCrud().get(id);
	}, [id]);

	return (
		<React.Fragment>
			<div>Edit Max Sales / Max Loss</div>

			{campaignStore.getCrud().isLoading ? (
				<Flex justifyContent="center" height="260px">
					<Spinner size={'40px'} />
				</Flex>
			) : (
				<React.Fragment>
					<Spacer />
					{links.length === 0 ? (
						<div className={styles.emptyState}>No destinations found for this campaign</div>
					) : (
						<DestinationsWeightTable links={links} editable />
					)}
				</React.Fragment>
			)}
		</React.Fragment>
	);
});
